import {
    // addTodolistAC,
    // changeFilterAC,
    // changeTodolistTitleAC,
    // removeTodolistAC,
    // setEntityStatusAC,
    // setTodolists
} from "../../features/Todolists/todolists-reducer";


export enum RESULT_CODES {
    succeeded = 0,
    error = 1,
    // bad_captcha = 2
}
